/**
 * TeamSystem Impact - M&A API Client
 *
 * Sola lettura: i fascicoli di due diligence li scrive l'assistente ESGM&A via
 * MCP. La lista contiene solo il nome in codice — il nome reale del target
 * arriva unicamente nel dettaglio, e solo a chi è autorizzato a quel deal.
 */

import { apiClient } from '../../api/client';

export interface DealSummary {
  dealId: string;
  redFlagCount: number;
  maxSeverity: number;
  escalationOpen: boolean;
  updatedAt: string;
}

export interface RedFlag {
  theme: string;
  reason: string;
  severity: number;
}

export interface Touchpoint {
  type: 'questionario_ricevuto' | 'call' | 'richiesta_dati' | 'escalation' | 'nota';
  note: string;
  date: string;
}

export interface DealDetail {
  dealId: string;
  company: {
    name: string;
    sector?: string;
    product?: string;
    size?: string;
    country?: string;
  };
  redFlags: RedFlag[];
  conclusions: string[];
  actionPoints: string[];
  iroLinks: string[];
  briefingSnapshot: string;
  esgOfficeCorrection: string;
  outcome: { materialized?: boolean; note?: string };
  escalation: { required: boolean; reason?: string; status?: 'open' | 'closed'; requestedAt?: string };
  createdAt: string;
  updatedAt: string;
  touchpoints: Touchpoint[];
}

interface ApiResponse<T> {
  success: boolean;
  data?: T;
  error?: string;
}

const BASE_PATH = '/ma';

export const maApi = {
  fetchMyDeals: async (): Promise<DealSummary[]> => {
    const response = await apiClient.get<ApiResponse<DealSummary[]>>(`${BASE_PATH}/deals`);
    if (!response.data.success) throw new Error(response.data.error || 'Failed to fetch deals');
    return response.data.data!;
  },

  fetchDeal: async (dealId: string): Promise<DealDetail> => {
    const response = await apiClient.get<ApiResponse<DealDetail>>(
      `${BASE_PATH}/deals/${encodeURIComponent(dealId)}`,
    );
    if (!response.data.success) throw new Error(response.data.error || 'Failed to fetch deal');
    return response.data.data!;
  },
};
